import type { InjectionKey } from 'vue'

import type { ButtonProps } from '@bigin/components/button'

export interface ButtonGroupContext {
  size?: ButtonProps['size']
  type?: ButtonProps['type']
  rounded?: ButtonProps['rounded']
}

export const buttonGroupContextKey: InjectionKey<ButtonGroupContext> = Symbol(
  'buttonGroupContextKey'
)
